// @TODO
export const AppLoader = () => null
